module.exports = __webpack_public_path__ + "img/dji-matrice-210.62fe7862.jpg";